<widget-section
  [displayTitle]="false"
  [widgets]="widgets"
>
</widget-section>
